import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "spSocialWrap" }
const _hoisted_2 = { class: "list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuoteTweet = _resolveComponent("QuoteTweet")!
  const _component_QuoteFacebook = _resolveComponent("QuoteFacebook")!
  const _component_QuoteLine = _resolveComponent("QuoteLine")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "article_sns_tooltip",
    style: _normalizeStyle({top: `${_ctx.state.y}px`, left: `${_ctx.state.x}px`})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", _hoisted_2, [
        _createVNode(_component_QuoteTweet, {
          text: _ctx.state.text
        }, null, 8, ["text"]),
        _createVNode(_component_QuoteFacebook, {
          text: _ctx.state.text
        }, null, 8, ["text"]),
        _createVNode(_component_QuoteLine, {
          text: _ctx.state.text
        }, null, 8, ["text"])
      ])
    ])
  ], 4)), [
    [_vShow, _ctx.state.view]
  ])
}